import React from 'react';
import { Link } from 'react-router-dom';

import dumbBem from 'dumb-bem';
import tx from 'transform-props-with';
import iterioLogo from 'images/logo.svg';

const dumbFooter = dumbBem('l-footer');
const Icon = tx([{ element: 'icon' }, dumbFooter])('div');

const Logo = () => {
  return (
    <Link to="/">
      <Icon modifier="logo">
        <img src={iterioLogo} alt="Iterio logo" />
      </Icon>
    </Link>
  );
};

export default Logo;



// WEBPACK FOOTER //
// ./src/components/landing/components/footer/Logo.jsx